import {
  ListAltOutlined as ListAltOutlinedIcon,
  InsertChartOutlinedRounded as InsertChartOutlinedRoundedIcon,
  DescriptionOutlined as DescriptionOutlinedIcon,
  ReceiptLongOutlined as ReceiptLongOutlinedIcon,
  HistoryOutlined as HistoryOutlinedIcon,
  SupervisorAccountOutlined as SupervisorAccountOutlinedIcon,
  LightbulbOutlined as LightbulbOutlinedIcon,
  AccountCircleOutlined as AccountCircleOutlinedIcon,
  ManageAccountsOutlined as ManageAccountsOutlinedIcon,
} from '@mui/icons-material';

import { ROUTES } from 'utils/constants';

import config from 'config';

import { SideMenuType } from 'app/components/SideMenu/types';

const className = 'd-flex radius-6 p-12';
const iconClassName = 'f-24 text-tertiary';

export const sideMenuNonAdminList: SideMenuType[] = [
  {
    key: 'jobLogs',
    displayName: 'Job Log',
    redirectTo: ROUTES.jobLogsPage,
    pathName: ROUTES.jobLogsPage,
    className,
    getIcon: () => <ListAltOutlinedIcon className={iconClassName} />,
  },
];

export const sideMenuSuperAdminList: SideMenuType[] = [
  ...sideMenuNonAdminList,
  {
    key: 'jobStage',
    displayName: 'Job Stage',
    redirectTo: ROUTES.jobStagePage,
    pathName: ROUTES.jobStagePage,
    className,
    getIcon: () => <InsertChartOutlinedRoundedIcon className={iconClassName} />,
  },
  {
    key: 'dataQuote',
    displayName: 'Data & Quote',
    redirectTo: ROUTES.dataQuotePaginatedRoute,
    pathName: ROUTES.dataQuotePage,
    className,
    getIcon: () => <DescriptionOutlinedIcon className={iconClassName} />,
  },
  {
    key: 'invoices',
    displayName: 'Invoices',
    redirectTo: ROUTES.invoicesPaginatedRoute,
    pathName: ROUTES.invoicesPage,
    className,
    getIcon: () => <ReceiptLongOutlinedIcon className={iconClassName} />,
  },
  {
    key: 'history',
    displayName: 'History',
    redirectTo: ROUTES.historyPage,
    pathName: ROUTES.historyPage,
    className,
    getIcon: () => <HistoryOutlinedIcon className={iconClassName} />,
  },
  {
    key: 'client',
    displayName: 'Clients',
    redirectTo: ROUTES.clientsPaginatedRoute,
    pathName: ROUTES.clientsPage,
    className,
    getIcon: () => <SupervisorAccountOutlinedIcon className={iconClassName} />,
  },
  {
    key: 'scopes',
    displayName: 'Scopes',
    redirectTo: ROUTES.scopesPaginatedRoute,
    pathName: ROUTES.scopesPage,
    className,
    getIcon: () => <LightbulbOutlinedIcon className={iconClassName} />,
  },
  {
    key: 'users',
    displayName: 'Users',
    redirectTo: ROUTES.ormsUsersPaginatedRoute,
    pathName: ROUTES.usersPage,
    className,
    getIcon: () => <AccountCircleOutlinedIcon className={iconClassName} />,
  },
  // ORMS Admin is appended below, behind a flag.
];

/* ORMS Admin sits directly below Users, and is super-admin only. */
const adminSideMenuItem: SideMenuType = {
  key: 'admin',
  displayName: 'Admin',
  redirectTo: ROUTES.adminPaginatedRoute,
  pathName: ROUTES.adminPage,
  className,
  getIcon: () => <ManageAccountsOutlinedIcon className={iconClassName} />,
};

/**
 * Admin is behind REACT_APP_SHOW_ADMIN_MENU so it can be live on staging for
 * ORMS to try while staying hidden in production. The page itself is NOT
 * removed — a super admin with the URL still reaches it, which is what makes
 * this a reveal switch rather than a feature kill.
 *
 * Reinstating it in production is setting the variable in deploy-prod.yml and
 * redeploying. No code change.
 */
if (config.showAdminMenu) {
  sideMenuSuperAdminList.push(adminSideMenuItem);
}

/**
 * The ormsAdmin menu is derived from the super-admin one, so anything added
 * there leaks here unless it is filtered out. Admin is super-admin only.
 */
const superAdminOnlyKeys = ['invoices', 'admin'];

export const sideMenuAdminList: SideMenuType[] = sideMenuSuperAdminList.filter(
  sideNav => !superAdminOnlyKeys.includes(sideNav.key),
);
